import React from 'react';

import { UnorderedList } from '../components/UnorderedList';

import { CirclePageSection, CirclePageSectionProps } from './CirclePageSection';
import { Grid } from './Grid';

interface CircleOnDemandPageSectionProps extends CirclePageSectionProps {
    children: React.ReactNode;
}

export const CircleOnDemandPageSection: React.FC<CircleOnDemandPageSectionProps> = ({
    children,
    ...props
}) => {
    return (
        <CirclePageSection {...props}>
            <Grid as={UnorderedList} minItemWidth={300} columnGap={20} rowGap={40} maxColumns={3}>
                {children}
            </Grid>
        </CirclePageSection>
    );
};
